const landingAsset = (fileName: string = ""): string => {
    const baseUrl = process.env.PUBLIC_URL || "";
    return `${baseUrl}/assets/landing/${fileName}`;
};

export default landingAsset;
